module.exports = __webpack_public_path__ + "static/media/montblanc-coin-in-reverse.60ff791a.gif";